// @flow

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toastr } from 'react-redux-toastr';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel
} from 'react-accessible-accordion';

import styles from './depositSlip.scss';
import ZoomTable from '../../../commons/zoomTable/zoomTable';
import {
  getDepositSlipDetails,
  getUpdatedDepositSlipDetails,
  getFilteredData
} from './depositSlipRedux/depositSlipActionCreator';
import Select from '../../../commons/formElements/select/select';
import DenominationReciept from '../../../commons/denominationReciept/denominationReciept';
import Loader from '../../../commons/loader/loader';
import PrintDepositSlip from './depositSlipPrint';
import { strUsables, paymentTypeMap } from '../../../../services/helpers';
import InputField from '../../../commons/formElements/inputField/inputField';
import TextArea from '../../../commons/formElements/textArea/textArea';
import Attachments from '../../../commons/attachments/attachments';
import { MANUAL_ATTACHMENT_SLIP, depositTypeMap } from './depositSlipHelper';
import ActionButton from '../../../commons/actionButton/actionButton';

type Props = {
  depositType: string,
  getDepositSlipDetails: Function,
  getUpdatedDepositSlipDetails: Function,
  depositSlipState: Object,
  onBackClick: Function
};

type State = {
  slipDetails: Array<any>,
  isLoaded: boolean,
  currentRowClicked: Object,
  grandTotal: number,
  denominationDetails: Object,
  printSlipDetails: Array<any>,
  isGrandTotalValid: boolean
};

function isPopupBlocked() {
  const url = '';
  const newWin = window.open(url);

  if (!newWin || newWin.closed || typeof newWin.closed === 'undefined') {
    return true;
  }
  return false;
}

const Cell = props => (
  <span className={`${styles.cellWrapper} flex-33 l-row j-start`}>
    {props.header}
    {': '}
    <span className={styles.labelValues}>{props.value}</span>
  </span>
);

export class DepositSlip extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      slipDetails: null,
      isLoaded: null,
      currentRowClicked: null,
      grandTotal: 0,
      denominationDetails: {},
      printSlipDetails: null,
      isGrandTotalValid: null,
      collectionAmount: 0,
      selectedBank: null,
      selectedAccount: null,
      depositSlipNumber: '',
      selectedManualDepositReason: null,
      depositedAmount: '',
      manualSlipScreenshot: null,
      remarks: '',
      slipType: depositTypeMap.DIGITAL.key
    };

    this.reasonNameVal = { nameKey: 'reason', valKey: 'id' };
    this.bankNameVal = { nameKey: 'bankName', valKey: 'id' };
    this.accountNameVal = { nameKey: 'accountNumber', valKey: 'id' };
    this.setUploadFilesSelected = this.setUploadFilesSelected.bind(this);
    this.removeAttachedFile = this.removeAttachedFile.bind(this);
    this.updateTableData = this.updateTableData.bind(this);
    this.handleRemovalClick = this.handleRemovalClick.bind(this);
    this.updateDenominationDetails = this.updateDenominationDetails.bind(this);
    this.tableActionFunctions = {
      toggleRowRemoval: this.updateTableData
    };
    this.updatePrintClicked = this.updatePrintClicked.bind(this);
  }

  componentDidMount() {
    this.props.getDepositSlipDetails(
      this.props.depositType,
      depositTypeMap.DIGITAL.key
    );
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.depositSlipState.slipGenerationSuccessful &&
      nextProps.depositSlipState.slipGenerationSuccessful !==
        this.props.depositSlipState.slipGenerationSuccessful
    ) {
      this.props.onBackClick(this.props.depositType);
      toastr.success('Success', 'Deposit Slip Generation successful');
    }
    if (
      nextProps.depositSlipState.data &&
      nextProps.depositSlipState.data !== this.props.depositSlipState.data
    ) {
      const collectionAmount =
        (nextProps.depositSlipState.data &&
          nextProps.depositSlipState.data.depositSlipRowDTOList.reduce(
            (acc, curr) => acc + curr.amount,
            0
          )) ||
        0;
      const depositSlipNumber =
        nextProps.depositSlipState.data.depositSlipDTO &&
        nextProps.depositSlipState.data.depositSlipDTO.depositSlipType ===
          'DIGITAL' &&
        nextProps.depositSlipState.data.depositSlipDTO.depositSlipNumber
          ? nextProps.depositSlipState.data.depositSlipDTO.depositSlipNumber
          : '';
      this.setState({
        slipDetails: JSON.parse(
          JSON.stringify(nextProps.depositSlipState.data)
        ),
        collectionAmount,
        depositSlipNumber
      });
    }

    if (
      nextProps.depositSlipState.printSlipDetails &&
      nextProps.depositSlipState.printSlipDetails !==
        this.props.depositSlipState.printSlipDetails
    ) {
      this.setState({
        printSlipDetails: JSON.parse(
          JSON.stringify(nextProps.depositSlipState.printSlipDetails)
        )
      });
    }

    if (nextProps.depositSlipState.fetched && !this.state.isLoaded) {
      this.setState({
        isLoaded: true
      });
    }
  }

  onBankSelect(val, obj) {
    if (obj === this.state.selectedBank) {
      return;
    }
    this.setState({
      selectedBank: obj,
      selectedAccount: null
    });
  }

  onSelectChange(val, obj, field) {
    this.setState({
      [field]: obj
    });
  }

  getTableDataAndLength(data) {
    return [data, data.length];
  }

  getBankAccountNumbers() {
    if (
      !this.state.selectedBank ||
      !(
        this.state.slipDetails &&
        this.state.slipDetails.metaStoreBankDetailDTOList
      )
    ) {
      return [];
    }
    const selectedbankDetails = this.state.slipDetails.metaStoreBankDetailDTOList.find(
      bank => bank.bankCode === this.state.selectedBank.bankCode
    );
    return selectedbankDetails.accounts;
  }

  setValue(field, val) {
    this.setState({
      [field]: val
    });
  }

  setUploadFilesSelected(newFile, attachementFor) {
    if (attachementFor === MANUAL_ATTACHMENT_SLIP) {
      return this.setState({
        manualSlipScreenshot: newFile
      });
    }
    return '';
  }

  removeAttachedFile(attachementFor) {
    if (attachementFor === MANUAL_ATTACHMENT_SLIP) {
      return this.setState({
        manualSlipScreenshot: null
      });
    }
    return '';
  }

  updatePrintClicked() {
    this.setState({
      printClicked: false
    });
  }

  checkGrandTotalValidity() {
    this.setState({
      isGrandTotalValid: this.checkIfTotalAmountEqualToGrandTotal()
    });
  }

  handleRemovalClick() {
    const [slipDetails, tableData, rowData] = [
      this.state.slipDetails,
      this.state.slipDetails.depositSlipRowDTOList,
      this.state.currentRowClicked
    ];
    let [collectionAmount] = [this.state.collectionAmount];
    const rowIndex = tableData.findIndex(row => row.cnote === rowData.cnote);
    tableData[rowIndex].isSelected = false;

    slipDetails.depositSlipDTO.numberOfInstruments -= 1;

    collectionAmount -= tableData[rowIndex].amount;
    this.setState(
      {
        currentRowClicked: null,
        slipDetails,
        collectionAmount
      },
      () => {
        this.checkGrandTotalValidity();
      }
    );
  }

  handleOptionChange(changeEvent) {
    this.setState(
      {
        slipType: changeEvent.currentTarget.value,
        selectedBank: null,
        selectedAccount: null,
        selectedManualDepositReason: null,
        remarks: '',
        depositedAmount: '',
        manualSlipScreenshot: null,
        filters: ''
      },
      () => {
        this.props.getDepositSlipDetails(
          this.props.depositType,
          this.state.slipType
        );
      }
    );
  }

  fillDto(slipDetails, slipType) {
    slipDetails.depositSlipDTO.collectionAmount = this.state.collectionAmount;
    if (slipType === depositTypeMap.DIGITAL.key) {
      slipDetails.depositSlipDTO.depositedAmount = 0;
    } else {
      slipDetails.depositSlipDTO.depositSlipNumber = this.state.depositSlipNumber;
      slipDetails.depositSlipDTO.depositedAmount = this.state.depositedAmount;
      slipDetails.depositSlipDTO.bankName =
        this.state.selectedBank && this.state.selectedBank.bankName;
      slipDetails.depositSlipDTO.bankAccountNo =
        this.state.selectedAccount && this.state.selectedAccount.accountNumber;

      slipDetails.depositSlipDTO.bankAccountReference =
        this.state.selectedAccount && this.state.selectedAccount.id;

      slipDetails.depositSlipDTO.reason =
        this.state.selectedManualDepositReason &&
        this.state.selectedManualDepositReason.reason;
      slipDetails.depositSlipDTO.reasonId =
        this.state.selectedManualDepositReason &&
        this.state.selectedManualDepositReason.id;
      slipDetails.depositSlipDTO.remarks = this.state.remarks;
    }
    return slipDetails;
  }

  updateDenominationDetails(grandTotal, denominationDetails) {
    this.setState(
      {
        denominationDetails,
        grandTotal
      },
      () => {
        this.checkGrandTotalValidity();
      }
    );
  }

  updateTableData(rowData) {
    const { slipDetails } = this.state;
    const [tableData] = [slipDetails.depositSlipRowDTOList];
    let [collectionAmount] = [this.state.collectionAmount];
    const rowIndex = tableData.findIndex(row => row.cnote === rowData.cnote);
    if (rowData.isSelected === undefined || rowData.isSelected === true) {
      this.setState(
        {
          currentRowClicked: rowData
        },
        () => {
          this.handleRemovalClick();
        }
      );
    } else {
      tableData[rowIndex].isSelected = true;
      collectionAmount += tableData[rowIndex].amount;
      slipDetails.depositSlipDTO.numberOfInstruments += 1;
    }
    this.setState(
      {
        slipDetails,
        collectionAmount
      },
      () => {
        this.checkGrandTotalValidity();
      }
    );
  }

  checkIfTotalAmountEqualToGrandTotal() {
    return this.state.collectionAmount === this.state.grandTotal;
  }

  handlePrintClick() {
    // 2seconds loading time needed for browser to detect new empty tab as a popup
    setTimeout(() => {
      const testPopupBlock = window.open('', '_blank');
      if (!testPopupBlock) {
        const errMsg =
          'Popups are blocked, please unblock it from the browser settings';

        toastr.error('Error', errMsg);
        testPopupBlock.close();
        return;
      }
      testPopupBlock.close();

      if (
        this.props.depositType === paymentTypeMap.CASH.key &&
        !this.checkIfTotalAmountEqualToGrandTotal()
      ) {
        toastr.error('Failure', 'Please check the denomination amount', {
          timeout: 3000
        });
      } else if (!isPopupBlocked()) {
        let { slipDetails } = this.state;
        slipDetails = this.fillDto(slipDetails, this.state.slipType);
        this.setState(
          {
            isGrandTotalValid: true,
            printClicked: true,
            slipDetails
          },
          () =>
            this.props.getUpdatedDepositSlipDetails(
              this.state.slipDetails,
              this.state.slipType,
              null
            )
        );
      } else {
        const errMsg =
          'Popups are blocked, please unblock it from the browser settings';

        toastr.error('Error', errMsg);
      }
    }, 2000);
  }

  handleSubmitClick() {
    if (!this.state.depositSlipNumber) {
      toastr.error('Error', 'Please enter deposit slip number');
      return;
    }
    if (!this.state.selectedBank) {
      toastr.error('Error', 'Please select a bank');
      return;
    }
    if (!this.state.selectedAccount) {
      toastr.error('Error', 'Please select an account');
      return;
    }
    if (!this.state.depositedAmount) {
      toastr.error('Error', 'Please enter depositing amount');
      return;
    }
    if (this.state.depositedAmount <= 0) {
      toastr.error('Error', 'Please enter valid depositing amount');
      return;
    }
    if (!this.state.selectedManualDepositReason) {
      toastr.error('Error', 'Please select a reason for manual deposit');
      return;
    }
    if (!this.state.manualSlipScreenshot) {
      toastr.error(
        'Error',
        'Please upload the manual deposit slip with slip number'
      );
      return;
    }
    let { slipDetails } = this.state;
    slipDetails = this.fillDto(slipDetails, this.state.slipType);
    this.setState(
      {
        isGrandTotalValid: true,
        slipDetails
      },
      () =>
        this.props.getUpdatedDepositSlipDetails(
          this.state.slipDetails,
          this.state.slipType,
          this.state.manualSlipScreenshot
        )
    );
  }

  rendorManualSlipDetails() {
    return (
      <div className={`${styles.manualSlipWrapper} flex-25 l-col`}>
        <div className={`${styles.blockWrapper}`}>
          <div className={`${styles.blockHeader}`}>Select Bank</div>
          <Select
            label="Select Bank"
            optionsArrOfObj={
              this.state.slipDetails &&
              this.state.slipDetails.metaStoreBankDetailDTOList
                ? this.state.slipDetails.metaStoreBankDetailDTOList
                : []
            }
            nameValStrings={this.bankNameVal}
            selectedOpt={this.state.selectedBank}
            onSelect={(val, obj) => {
              this.onBankSelect(val, obj);
            }}
            disabled={false}
            enableSearch={true}
            disableNone={true}
            selectedWrapperClass="white-background"
          />
        </div>
        <div className={`${styles.blockWrapper}`}>
          <div className={`${styles.blockHeader}`}>Account Number</div>
          <Select
            label="Select Account Number"
            optionsArrOfObj={this.getBankAccountNumbers()}
            onSelect={(val, obj) => {
              this.onSelectChange(val, obj, 'selectedAccount');
            }}
            nameValStrings={this.accountNameVal}
            selectedOpt={this.state.selectedAccount}
            disabled={false}
            enableSearch={true}
            disableNone={true}
            selectedWrapperClass="white-background"
          />
        </div>
        <div className={`${styles.blockWrapper}`}>
          <div className={`${styles.blockHeader}`}>Deposited Amount</div>
          <InputField
            label=""
            placeholder="Enter deposited amount"
            allowedInputKeys="decimalnumber"
            type="text"
            value={this.state.depositedAmount}
            disabled={false}
            onChange={val => this.setValue('depositedAmount', val)}
          />
        </div>
        <div className={`${styles.blockWrapper} j-space-bet`}>
          <div className={`${styles.blockHeader}`}>
            Reasons for Manual Deposit
          </div>
          <Select
            label="Select reason"
            optionsArrOfObj={
              this.state.slipDetails &&
              this.state.slipDetails.manualDepositReasons
                ? this.state.slipDetails.manualDepositReasons
                : []
            }
            selectedOpt={this.state.selectedManualDepositReason}
            nameValStrings={this.reasonNameVal}
            onSelect={(val, obj) => {
              this.onSelectChange(val, obj, 'selectedManualDepositReason');
            }}
            disabled={false}
            enableSearch={true}
            disableNone={true}
            selectedWrapperClass="white-background"
          />
        </div>
        <div className={`${styles.blockWrapper}`}>
          <div className={`${styles.blockHeader}`}>Remarks</div>
          <TextArea
            inputClassName={styles.textArea}
            rows={4}
            value={this.state.remarks}
            onChange={val => this.setValue('remarks', val)}
          />
        </div>
        <div className={`${styles.blockWrapper}`}>
          <div className={`${styles.labelValues}`}>
            &#9432; {'  '} Write slip number {this.state.depositSlipNumber} on
            deposit slip before upload.
          </div>
        </div>
        <div className={`${styles.blockWrapper}`}>
          <div className={`${styles.labelValues}`}>Upload Slip</div>
          <div>
            {this.renderAttachmentsComponent(
              this.state.manualSlipScreenshot &&
                this.state.manualSlipScreenshot.length > 0
                ? this.state.manualSlipScreenshot[0].name
                : ''
            )}
          </div>
        </div>
      </div>
    );
  }

  renderAttachmentsComponent(loadedFileName) {
    return (
      <Attachments
        attachmentFor={MANUAL_ATTACHMENT_SLIP}
        loadedFileName={loadedFileName}
        dropzoneWrapperStyle={`${styles.dropzoneWrapperStyle}`}
        attachmentModalWrapper={`${styles.attachmentModalWrapper}`}
        heading=" "
        attachmentWrapper={`${styles.attachmentWrapper}`}
        setUploadFilesSelected={this.setUploadFilesSelected}
        removeAttachedFile={this.removeAttachedFile}
      />
    );
  }

  renderZoomTableComponent(data) {
    return (
      <ZoomTable
        key={data.key}
        configKey={data.configKey}
        tableData={data.tableData}
        tableDataLength={data.tableDataLength}
        actionFunctions={this.tableActionFunctions}
        paginationProps={{ showPagination: true, pageSize: 20 }}
      />
    );
  }

  renderDenominationComponent() {
    return (
      <DenominationReciept
        passDenominationDetailsToParent={this.updateDenominationDetails}
        isGrandTotalValid={this.state.isGrandTotalValid}
      />
    );
  }

  renderCashTable(tableData, tableDataLength) {
    return (
      <div className="flex-100 l-row j-space-bet">
        <div
          className={`${styles.depositTable} ${
            this.state.slipType === depositTypeMap.DIGITAL.key
              ? 'flex-65'
              : 'flex-100'
          } l-row`}
        >
          {this.renderZoomTableComponent({
            key: 'DEPOSIT_SLIP_CASH',
            configKey: 'DEPOSIT_SLIP_CASH',
            tableData,
            tableDataLength
          })}
        </div>
        {this.state.slipType === depositTypeMap.DIGITAL.key ? (
          <div className={`${styles.depositTable} flex-30 l-row`}>
            {this.renderDenominationComponent()}
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }

  renderChequeTable(tableData, tableDataLength) {
    return (
      <div className={`${styles.depositTable} flex-100 l-row`}>
        {this.renderZoomTableComponent({
          key: 'DEPOSIT_SLIP_CHEQUE',
          configKey: 'DEPOSIT_SLIP_CHEQUE',
          tableData,
          tableDataLength
        })}
      </div>
    );
  }

  renderSlipPages() {
    const [tableData, tableDataLength] = this.state.slipDetails
      ? this.getTableDataAndLength(this.state.slipDetails.depositSlipRowDTOList)
      : [[], 0];
    return (
      <div id="depositSlip">
        <div
          className={`${styles.depositSlipWrapper} flex-100 j-space-aro l-col`}
        >
          <div className="l-row j-space-bet">
            <div
              className={`${
                this.state.slipType === depositTypeMap.DIGITAL.key
                  ? 'flex-100'
                  : 'flex-70'
              }`}
            >
              <div className={`${styles.radioButtonsContainer} l-row`}>
                <label
                  htmlFor="digital_radio"
                  className={`${styles.radioContainer} l-row`}
                >
                  <input
                    type="radio"
                    id="digital_radio"
                    value={depositTypeMap.DIGITAL.key}
                    checked={this.state.slipType === depositTypeMap.DIGITAL.key}
                    onChange={event => this.handleOptionChange(event)}
                    className={`${styles.checkInput}`}
                  />
                  Digital slip
                  <span className={styles.checkmark} />
                </label>
                <label
                  htmlFor="manual_radio"
                  className={`${styles.radioContainer} l-row`}
                >
                  <input
                    type="radio"
                    id="manual_radio"
                    value={depositTypeMap.MANUAL.key}
                    checked={this.state.slipType === depositTypeMap.MANUAL.key}
                    onChange={event => this.handleOptionChange(event)}
                    className={`${styles.checkInput}`}
                  />
                  Manual slip
                  <span className={styles.checkmark} />
                </label>
              </div>
              <div className={styles.blockContainer}>
                <div className={`${styles.blockWrapper} ${styles.flex3}`}>
                  <div className={`${styles.blockWrapper} l-row`}>
                    <div className="flex-100 l-row">
                      <span className="flex-100 l-row j-start">
                        Client Name{' '}
                        <span className={styles.labelValues}>
                          {this.state.slipDetails &&
                            this.state.slipDetails.depositSlipDTO.clientName}
                        </span>
                      </span>
                    </div>
                  </div>
                  <div className={`${styles.blockWrapper} l-row`}>
                    <div className="flex-100 l-row">
                      <Cell
                        header="CMS Code"
                        value={
                          this.state.slipDetails &&
                          this.state.slipDetails.depositSlipDTO.cmsCode
                        }
                      />
                      <Cell
                        header="Select the mode"
                        value={
                          this.state.slipDetails &&
                          this.state.slipDetails.depositSlipDTO.paymentType
                        }
                      />
                      <Cell
                        header="No of instruments"
                        value={
                          this.state.slipDetails &&
                          this.state.slipDetails.depositSlipDTO
                            .numberOfInstruments
                        }
                      />
                    </div>
                  </div>
                  <div className={`${styles.blockWrapper} l-row`}>
                    <div className="flex-100 l-row">
                      <Cell
                        header="Pickup date"
                        value={
                          this.state.slipDetails &&
                          this.state.slipDetails.depositSlipDTO
                            .depositSlipGenerationDate
                        }
                      />
                      <Cell
                        header="Pickup location"
                        value={
                          this.state.slipDetails &&
                          this.state.slipDetails.depositSlipDTO.pickupBranch
                        }
                      />
                      <Cell
                        header="Pick up point"
                        value={
                          this.state.slipDetails &&
                          this.state.slipDetails.depositSlipDTO.pickupPoint
                        }
                      />
                    </div>
                  </div>
                  <div className={`${styles.blockWrapper} l-row`}>
                    <div className="flex-100 l-row">
                      {this.state.slipType === depositTypeMap.DIGITAL.key ? (
                        <Cell
                          header="Deposit slip number"
                          value={this.state.depositSlipNumber}
                        />
                      ) : (
                        <div className="flex-50 l-row j-start">
                          <span className={`${styles.cellWrapper} flex-50`}>
                            {'Deposit slip number:'}
                          </span>
                          <InputField
                            label=""
                            placeholder="Enter Slip Number"
                            allowedInputKeys="onlynumber"
                            type="text"
                            value={this.state.depositSlipNumber}
                            inputFieldWrapperClass={`${styles.inputFieldWrapper}`}
                            onChange={val =>
                              this.setValue('depositSlipNumber', val)
                            }
                          />
                        </div>
                      )}
                      <Cell
                        header="Deposit date"
                        value={
                          this.state.slipDetails &&
                          this.state.slipDetails.depositSlipDTO
                            .depositSlipGenerationDate
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className={`${styles.flex1}`}>{this.renderFilters()}</div>
              </div>
              <div className={`${styles.blockWrapper} l-row`}>
                {this.props.depositType === paymentTypeMap.CASH.key
                  ? this.renderCashTable(tableData, tableDataLength)
                  : this.renderChequeTable(tableData, tableDataLength)}
              </div>
            </div>
            {this.state.slipType === depositTypeMap.MANUAL.key
              ? this.rendorManualSlipDetails()
              : ''}
          </div>
          <div id="1" className={`${styles.blockWrapper}`}>
            <div className="flex-100 l-row a-center">
              <span
                className={`flex-65 l-row j-start ${styles.collectionAmount}`}
              >
                Total Collection Amount:{' '}
                <span className={styles.labelValues}>
                  {strUsables.indianCurrencySymol} {this.state.collectionAmount}
                </span>
              </span>

              {this.state.slipType === depositTypeMap.DIGITAL.key ? (
                <span className="flex-35 l-row j-end">
                  Kindly print 4 copies of this deposit slip{' '}
                </span>
              ) : (
                ''
              )}
            </div>
          </div>
          <div className={`${styles.blockWrapper} ${styles.slipBottom}`}>
            <div>
              {this.state.slipType === depositTypeMap.DIGITAL.key ? (
                <div
                  className={`${styles.blockWrapper} flex-100 l-row a-center`}
                >
                  <span className="flex-25 l-row j-start">Deposited By </span>
                  <span className="flex-25 l-row j-start">Branch</span>
                  <span className="flex-25 l-row j-start">Bank Stamp</span>
                </div>
              ) : (
                ''
              )}
              <div className={`${styles.blockWrapper} flex-100 l-row`}>
                <div className="flex-50 l-row j-start">
                  <div className="action-button-wrapper">
                    <button
                      id="backButton"
                      className={`action-button ${styles.depositActionButtons}`}
                      onClick={() =>
                        this.props.onBackClick(this.props.depositType)
                      }
                    >
                      Back
                    </button>
                  </div>
                </div>
                <div className="flex-50 l-row j-end">
                  {this.state.slipType === depositTypeMap.DIGITAL.key ? (
                    <div className="action-button-wrapper">
                      <button
                        id="print"
                        className={`${styles.printButton} action-button ${styles.depositActionButtons}`}
                        onClick={() => {
                          this.handlePrintClick();
                        }}
                        disabled={
                          this.props.depositType === paymentTypeMap.CASH.key
                            ? !this.state.isGrandTotalValid ||
                              !(
                                this.state.slipDetails &&
                                this.state.slipDetails.depositSlipDTO &&
                                this.state.slipDetails.depositSlipDTO
                                  .numberOfInstruments !== 0
                              )
                            : !(
                                this.state.slipDetails &&
                                this.state.slipDetails.depositSlipDTO &&
                                this.state.slipDetails.depositSlipDTO
                                  .numberOfInstruments !== 0
                              )
                        }
                      >
                        Print
                      </button>
                    </div>
                  ) : (
                    <div className="action-button-wrapper">
                      <button
                        id="submit"
                        className={`${styles.printButton} action-button ${styles.depositActionButtons}`}
                        onClick={() => {
                          this.handleSubmitClick();
                        }}
                        disabled={
                          !(
                            this.state.slipDetails &&
                            this.state.slipDetails.depositSlipDTO &&
                            this.state.slipDetails.depositSlipDTO
                              .numberOfInstruments !== 0
                          )
                        }
                      >
                        SUBMIT
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.printClicked && this.state.printSlipDetails ? (
          <div className="is-hidden">
            <PrintDepositSlip
              printData={this.state.printSlipDetails}
              depositType={this.props.depositType}
              denominationDetails={this.state.denominationDetails}
              grandTotal={this.state.grandTotal}
              collectionAmount={this.state.collectionAmount}
              updatePrintClicked={this.updatePrintClicked}
            />
            {this.props.onBackClick(this.props.depositType)}
          </div>
        ) : null}
      </div>
    );
  }
  applyFilter() {
    let filterString = this.state.filters;
    filterString = filterString.trim();
    const filterArray = filterString
      .split('\n')
      .join(' ')
      .split(' ')
      .filter(item => {
        if (item) {
          return item;
        }
      });
    this.props.getFilteredData(filterArray);
  }
  renderFilters() {
    return (
      <Accordion allowZeroExpanded>
        <AccordionItem>
          <AccordionItemHeading>
            <AccordionItemButton>Filters</AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <div className={styles.filters}>
              <div>
                <TextArea
                  placeholder="Enter cnote numbers separated by space"
                  inputClassName={styles.filterText}
                  rows={4}
                  value={this.state.filters}
                  onChange={val => this.setValue('filters', val)}
                />
              </div>
              <div className={styles.filtersButtonWrapper}>
                <div>
                  <button
                    className={`action-button ${styles.filtersActionButton} ${styles.white}`}
                    onClick={() =>
                      this.setState({
                        filters: ''
                      })
                    }
                  >
                    Clear
                  </button>
                </div>
                <div>
                  <button
                    className={`action-button ${styles.filtersActionButton}`}
                    onClick={() => {
                      this.applyFilter();
                    }}
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </AccordionItemPanel>
        </AccordionItem>
      </Accordion>
    );
  }

  render() {
    if (this.state.isLoaded) {
      return this.renderSlipPages();
    }
    return <Loader />;
  }
}

const mapStateToProps = state => ({
  depositSlipState: state.depositSlipState
});

const mapDispatchToProps = dispatch => ({
  getDepositSlipDetails: bindActionCreators(getDepositSlipDetails, dispatch),
  getUpdatedDepositSlipDetails: bindActionCreators(
    getUpdatedDepositSlipDetails,
    dispatch
  ),
  getFilteredData: bindActionCreators(getFilteredData, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(DepositSlip);
